import { Component, ChangeDetectionStrategy } from '@angular/core';
import {RouterLink} from "@angular/router";
import {NgOptimizedImage} from "@angular/common";

@Component({
    selector: 'app-legal',
  imports: [
    RouterLink,
    NgOptimizedImage,
    NgOptimizedImage
  ],
    templateUrl: './legal.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './legal.page.scss'
})
export class LegalPage {

}
